import React, { Component } from "react"
import { Link } from "gatsby"
import LogoutButton from "../Logout"
import logo from "../../images/hrs-logo.png"

function LoginLogoutButton(props) {
  if (props.loggedIn) {
    return <LogoutButton />
  } else {
    return (
      <Link to="/login/" className="default-btn mr-3">
        <i className="bx bxs-log-in"></i> Log In <span></span>
      </Link>
    )
  }
}

class Navbar extends Component {
  // Navbar
  _isMounted = false
  state = {
    display: false,
    collapsed: true,
  }
  toggleNavbar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }
  componentDidMount() {
    let elementId = document.getElementById("navbar")
    document.addEventListener("scroll", () => {
      if (window.scrollY > 170) {
        elementId.classList.add("is-sticky")
      } else {
        elementId.classList.remove("is-sticky")
      }
    })
    window.scrollTo(0, 0)
  }
  componentWillUnmount() {
    this._isMounted = false
  }

  render() {
    const { collapsed } = this.state
    const classOne = collapsed
      ? "collapse navbar-collapse"
      : "collapse navbar-collapse show"
    const classTwo = collapsed
      ? "navbar-toggler navbar-toggler-right collapsed"
      : "navbar-toggler navbar-toggler-right"

    return (
      <React.Fragment>
        <div id="navbar" className="navbar-area bg-white">
          <div className="main-nav">
            <div className="container">
              <nav className="navbar navbar-expand-md navbar-light">
                <Link to="/" className="navbar-brand">
                  <img src={logo} alt="HRS Systems logo" className="logo" />
                </Link>

                <button
                  onClick={this.toggleNavbar}
                  className={classTwo}
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>

                <div className={classOne} id="navbarSupportedContent">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      {/*  this is here because without it the home button shifts up?????*/}
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/"
                        activeClassName="active"
                        className="nav-link"
                      >
                        Home
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link to="/hass" className="nav-link">
                        Products <i className="bx bx-chevron-down"></i>
                      </Link>

                      <ul className="dropdown-menu">
                        <li className="nav-item">
                          <Link
                            to="/hass"
                            activeClassName="active"
                            className="nav-link"
                          >
                            HASS
                          </Link>
                        </li>

                        <li className="nav-item">
                          <Link
                            to="/hasshouse"
                            activeClassName="active"
                            className="nav-link"
                          >
                            HASS House
                          </Link>
                        </li>

                        <li className="nav-item">
                          <Link
                            to="/coosa"
                            activeClassName="active"
                            className="nav-link"
                          >
                            COOSA
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="nav-item">
                      <Link
                        to="/pricing"
                        activeClassName="active"
                        className="nav-link"
                      >
                        Pricing
                      </Link>
                    </li>

                    {/*<li className="nav-item">*/}
                    {/*  <a></a>*/}
                    {/*  <Link*/}
                    {/*    to="/blog"*/}
                    {/*    activeClassName="active"*/}
                    {/*    className="nav-link"*/}
                    {/*  >*/}
                    {/*    Blog*/}
                    {/*  </Link>*/}
                    {/*</li>*/}

                    <li className="nav-item">
                      <Link to="/contact" className="nav-link">
                        Support <i className="bx bx-chevron-down"></i>
                      </Link>

                      <ul className="dropdown-menu">
                        <li className="nav-item">
                          <Link
                            to="/contact"
                            activeClassName="active"
                            className="nav-link"
                          >
                            Contact Us
                          </Link>
                        </li>

                        <li className="nav-item">
                          <Link
                            to="/videos"
                            activeClassName="active"
                            className="nav-link"
                          >
                            Training Videos
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="nav-item">
                      <Link
                        to="/account"
                        activeClassName="active"
                        className="nav-link"
                      >
                        Account
                      </Link>
                    </li>
                  </ul>
                  {/*<div className="others-options">*/}
                  {/*  <Link to="https://savvycal.com/hrssystems/hass-demo" className="default-btn mr-3">*/}
                  {/*    <i className="bx bxs-hot"></i> Book A Demo <span></span>*/}
                  {/*  </Link>*/}
                  {/*</div>*/}

                  <div className="others-options">
                    <LoginLogoutButton loggedIn={this.props.loggedIn} />
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Navbar
